import React from 'react'
import { FaRegThumbsUp, FaThumbsUp, FaRegThumbsDown, FaThumbsDown } from 'react-icons/fa'
import UserAvatar from './userAvatar'
import { parseCommentMedia } from '../utils/commentMedia'
import { commentDomId } from '../utils/commentFocus'
import '../styles/commentThread.css'

const formatCommentWhen = (value) => {
  if (!value) return ''
  const parsed = new Date(value)
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
  }
  return String(value)
}

const CommentMedia = ({ comment }) => {
  const media = parseCommentMedia(comment)
  if (!media) return null
  if (media.kind === 'video') {
    return (
      <div className="commentMedia">
        <video src={media.src} controls playsInline preload="metadata" />
      </div>
    )
  }
  return (
    <div className="commentMedia">
      <img src={media.src} alt="" />
    </div>
  )
}

const CommentThread = ({ comment, repliesByParent, onReply, onVote, onDelete, canDelete, depth = 0 }) => {
  const own = typeof canDelete === 'function' ? canDelete(comment) : Boolean(canDelete)
  const replies = repliesByParent[String(comment.id)] || []
  const nested = depth < 4 ? replies.slice(0, 4) : []
  const flat = depth < 4 ? replies.slice(4) : replies
  const showLine = nested.length > 0
  const media = parseCommentMedia(comment)
  const text = String(comment.content || '').trim()
  const showText = text && !(media && media.kind === 'gif' && text === media.src)

  return (
    <>
      <article id={commentDomId(comment.id)} className={`commentThread${showLine ? ' hasLine' : ''}${depth > 0 ? ' isReply' : ''}`}>
        <div className="commentRail">
          <UserAvatar className="commentAvatar" src={comment.userImg} name={comment.email} alt="" userId={comment.userid} />
          {showLine ? <span className="commentSpine" /> : null}
        </div>
        <div className="commentBody">
          <div className="commentCard">
            <strong>{comment.email}</strong>
            {showText ? <p>{text}</p> : null}
            <CommentMedia comment={comment} />
            <div className="commentMeta">
              <span className="commentWhen">{formatCommentWhen(comment.date)}</span>
              <button
                type="button"
                className={`commentVote${comment.userVote === 'p' ? ' active' : ''}`}
                onClick={() => onVote('p', comment.id)}
              >
                {comment.userVote === 'p' ? <FaThumbsUp /> : <FaRegThumbsUp />}
                <em>{Number(comment.pCount) || 0}</em>
              </button>
              <button
                type="button"
                className={`commentVote${comment.userVote === 'd' ? ' active' : ''}`}
                onClick={() => onVote('d', comment.id)}
              >
                {comment.userVote === 'd' ? <FaThumbsDown /> : <FaRegThumbsDown />}
                <em>{Number(comment.dCount) || 0}</em>
              </button>
              <button type="button" onClick={() => onReply(comment)}>Reply</button>
              {own && onDelete ? (
                <button type="button" className="commentDelete" onClick={() => onDelete(comment)}>Delete</button>
              ) : null}
            </div>
          </div>
          {nested.length > 0 ? (
            <div className="commentReplies">
              {nested.map(reply => (
                <CommentThread
                  key={reply.id}
                  comment={reply}
                  repliesByParent={repliesByParent}
                  onReply={onReply}
                  onVote={onVote}
                  onDelete={onDelete}
                  canDelete={canDelete}
                  depth={depth + 1}
                />
              ))}
            </div>
          ) : null}
        </div>
      </article>
      {flat.map(reply => (
        <CommentThread
          key={reply.id}
          comment={reply}
          repliesByParent={repliesByParent}
          onReply={onReply}
          onVote={onVote}
          onDelete={onDelete}
          canDelete={canDelete}
          depth={depth + 1}
        />
      ))}
    </>
  )
}

export default CommentThread
